export default __webpack_public_path__ + "static/media/micIcon.54d6d1f9.svg";